import React, {
	Component
} from 'react';
import Global from '../../Global';

import './LookingPlan.css';
import BackArrow from '../../svgs/back-arrow.svg';



function rgbtohsl(r, g, b) {
	r = r / 255;
	g = g / 255;
	b = b / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var difference = max - min;
	var h, s, l;
	l = (min + max) / 2;
	if (max === min) {
		h = 0;
		s = 0;
	} else {
		s = l > 0.5 ? difference / (2.0 - max - min) : difference / (max + min);
		switch (max) {
			case r:
				h = (g - b) / difference + (g < b ? 6 : 0);
				break;
			case g:
				h = 2.0 + (b - r) / difference;
				break;
			case b:
				h = 4.0 + (r - g) / difference;
				break;
			default:
				break;
		}
		h = Math.round(h * 60);
	}
	s = Math.round(s * 100); //转换成百分比的形式
	l = Math.round(l * 100);
	return [h, s, l];
}


class LookingPlan extends Component {

	constructor(props) {
		super(props);

		this.state = {
			imgKey: document.body.offsetWidth < 768 ? 'imageMob' : 'image',
			currentPlanId: null,
			stepQuestionId: [],
			stepQuestion: [],
			uiStep: null,
			data: {
				general: null,
				plans: null,
				steps: []
			}
		}
	}

	resetStep() {
		if (this.state.data.general && this.state.data.plans) {
			this.setState({
				currentPlanId: null,
				stepQuestionId: [],
				stepQuestion: [],
				uiStep: null
			})
			this.goToStep(-1);
		}
	}
	getLastEnableStep() {
		let checkIndex = this.state.stepQuestion.length - 1;
		while (checkIndex >= 0) {
			const plansOrQuestion = this.state.stepQuestion[checkIndex]
			if (plansOrQuestion) {
				if (plansOrQuestion.length > 1) {
					break;
				} else if (plansOrQuestion.length === 1) {
					checkIndex--;
					break;
				}
			}
			checkIndex--;
		}
		return checkIndex;
	}
	goBack(step) {
		const currentStep = typeof step === 'number' ? step : this.state.uiStep
		//if undefined, means uistep number is different with actrully active step number.
		if (this.state.stepQuestionId[currentStep] !== undefined &&
			this.state.stepQuestion[currentStep] === undefined) {
			this.goToStep(this.getLastEnableStep() - 1);
		} else {
			const backStep = currentStep - 1;
			const questionId = this.state.stepQuestionId[backStep];
			const questionOrPlans = this.state.stepQuestion[backStep];
			if (questionOrPlans) {
				if (questionOrPlans.length === 1) {
					this.goToStep(backStep - 1)
				} else {
					this.goToStep(backStep);
				}
			} else {
				//back from final step
				this.goToStep(this.getLastEnableStep());
			}
		}
	}

	changeCurrentPage(){
		if(this.props.change){
			// console.log("yes");
			this.props.change();
		}
	}

	goToStep(stepIndex) {
		if (this.state.uiStep !== stepIndex) {

			const updateState = {};
			let fn;
			if (stepIndex <= this.state.data.steps.length - 1) {
				if (stepIndex === -1) {
					this.selectAnswerForStep(0, null, this.state.stepQuestion[0] || this.state.data.steps[0]);
				} else {
					let nextId = this.state.stepQuestionId[stepIndex + 1] ||
						(this.state.stepQuestion[stepIndex] && this.state.stepQuestion[stepIndex].answers && this.state.stepQuestion[stepIndex].answers[0].id) || 0;
					const nextPlans = this.state.stepQuestion[stepIndex + 1] ||
						(this.state.stepQuestion[stepIndex] && this.state.stepQuestion[stepIndex].answers && this.state.stepQuestion[stepIndex].answers[0].plans);
					if (!nextPlans || !nextPlans.length) {
						this.selectAnswerForStep(stepIndex + 1, nextId);
					} else {
						updateState.currentPlanId = null;
						this.selectAnswerForStep(stepIndex + 1, this.state.stepQuestionId[stepIndex + 1] || 0, nextPlans);
					}

					const plans = this.state.stepQuestion[stepIndex];
					if (!this.state.currentPlanId) {
						updateState.currentPlanId = plans[parseInt(plans.length / 2, 10)]
					}
					//jump to next
					if (plans && plans.length) {
						if (plans.length === 1) {
							fn = _ => {
								this.goToStep(this.state.data.steps.length)
							}
						} else {
							fn = _ => {
								this.goToStep(this.state.data.steps.length - 1)
							}
						}
					}
				}
			}
			updateState.uiStep = stepIndex;
			this.setState(updateState, fn)
		}
	}

	selectAnswerForStep(stepIndex, answerId, answerData) {
		if (stepIndex < this.state.data.steps.length) {
			let stepQuestionId = this.state.stepQuestionId;
			let stepQuestion = this.state.stepQuestion;

			if (typeof answerId === 'string') {
				stepQuestionId[stepIndex] = answerId;
				stepQuestion[stepIndex] = this.state.data.steps[stepIndex][answerId];
			} else {
				stepQuestionId[stepIndex] = answerId;
				stepQuestion[stepIndex] = answerData;
			}

			stepQuestionId.splice(stepIndex + 1);
			stepQuestion.splice(stepIndex + 1);


			this.setState({
				stepQuestion,
				stepQuestionId
			})
		}
	}
	onPlanChange(currentPlanId) {
		this.setState({
			currentPlanId
		})
	}
	onPlanDrag(currentPlanId) {
		if (this.enableDrag) {
			this.setState({
				currentPlanId
			})
		}
	}
	onPlanStartDrag() {
		this.enableDrag = true;
	}
	onPlanStopDrag() {
		this.enableDrag = false;
	}

	componentDidMount() {

		var url = Global.getAPI('plans-advisor');
		fetch(url)
			.then(function (response) {
				if (response.status >= 400) {
					throw new Error('Error API: phone-advisor');
				}
				return response.json();
			})
			.then(data => {
				//add one more final step
				data.steps = data.steps || [];
				data.step1 && data.steps.push(data.step1);
				data.step2 && data.steps.push(data.step2);
				data.step3 && data.steps.push(data.step3);
				data.step4 && data.steps.push(data.step4);
				data.step5 && data.steps.push(data.step5);
				//one more the last step for selecting plan
				data.steps.push({})
				this.setState({
					data
				}, this.resetStep);
			});
	}

	render() {
		if (this.state.data.general && this.state.data.plans) {
			const self = this;
			const startAdvisor = this.state.uiStep !== -1;
			const selectPlanStepIndex = this.state.data.steps.length - 1;
			const theFinalStepIndex = selectPlanStepIndex + 1;
			const allStepCount = theFinalStepIndex + 1;

			let selectedPlans;
			let checkIndex = this.state.stepQuestion.length - 1;
			while (checkIndex >= 0) {
				const plansOrQuestion = this.state.stepQuestion[checkIndex]
				if (plansOrQuestion && plansOrQuestion.length) {
					selectedPlans = plansOrQuestion;
					break;
				}
				checkIndex--;
			}

			const selectedPlan = this.state.data.plans[this.state.currentPlanId];
			const selectedPlanIndex = selectedPlans && selectedPlans.indexOf(this.state.currentPlanId);
			const stepContainerLeft = (startAdvisor ? this.state.uiStep : 0) * -100 + '%';

			return <div className='looking-plan container clearfix'
				style={{ backgroundImage: 'url(' + encodeURI(this.state.data.general[this.state.imgKey]) + ')' }}
				onMouseDown={this.onPlanStartDrag.bind(this)}
				onMouseUp={this.onPlanStopDrag.bind(this)}
				onTouchStart={this.onPlanStartDrag.bind(this)}
				onTouchEnd={this.onPlanStopDrag.bind(this)}
			>
				<div className={'cover' + (startAdvisor ? ' in-steps ' : '') + (this.state.uiStep === theFinalStepIndex ? ' with-final ' : '')}></div>
				<div className={'find-plan' + (!startAdvisor ? ' active ' : '')}>
					<div className="content">
						<h1>{this.state.data.general.headline1}<br />{this.state.data.general.headline2}</h1>
						<span className='line'></span>
						<p className='description'>{this.state.data.general.text}</p>
						<button className='cta' tabIndex='-1' onClick={this.goToStep.bind(this, 0)}>{this.state.data.general.labelFindMyPlan}</button>
					</div>
				</div>
				<div className={'steps' + (startAdvisor ? ' active ' : '') + (this.state.uiStep === theFinalStepIndex ? ' with-final ' : '')}>
					<div className="top-line"></div>
					<div className="steps-canvas">
						<div className='steps-container' style={{ left: stepContainerLeft, width: allStepCount * 100 + '%' }}>

							{
								this.state.data.steps.map((step, stepIndex) => {
									const questionData = self.state.stepQuestion[stepIndex];
									const thisAnswerId = self.state.stepQuestionId[stepIndex + 1];
									if (stepIndex !== selectPlanStepIndex) {
										return <div className='step' style={{ width: 100 / allStepCount + '%' }} key={stepIndex}>
											{questionData ?
												<div className="question">
													{/*<h4 className='no'>{currentQuestionData.questionNo}</h4>*/}
													<h2 className="title">{<img alt="" className="back-arrow" onClick={stepIndex ? self.goBack.bind(self) : self.resetStep.bind(self)} src={BackArrow} />}
														{questionData.title}</h2>
													<div className="answers">
														{
															questionData.answers && questionData.answers.map((item, answerIndex) => {
																let inputID = item.id;
																if (item.plans && item.plans.length) {
																	inputID = answerIndex;
																}

																return <label htmlFor={stepIndex + '-' + inputID} key={answerIndex}>
																	<span className={'radio' + (thisAnswerId === inputID ? ' checked ' : '')}>
																		<input type='radio' name='step1' id={stepIndex + '-' + inputID}
																			value={stepIndex + '-' + inputID}
																			onChange={self.selectAnswerForStep.bind(self, stepIndex + 1, inputID, item.plans)}
																			checked={thisAnswerId === inputID} />
																	</span>
																	<span className='text'>{item.answer}</span>
																</label>
															})
														}
													</div>
													<div className="ctas">
														<button className="next" tabIndex='-1' onClick={self.goToStep.bind(self, stepIndex + 1)}>{self.state.data.general.labelNext}</button>
														<a className='all-plans-mobile' href={self.state.data.general.urlViewAllPlans} >{self.state.data.general.labelViewAllPlans}</a>
													</div>
												</div>
												:
												null
											}
										</div>
									}
									else {
										return <div className='step final-step' style={{ width: 100 / allStepCount + '%' }} key={stepIndex}>

											<div className="question">
												{/*<h4 className='no'>{currentQuestionData.questionNo}</h4>*/}
												<h2 className="title"><img className="back-arrow" alt="" onClick={this.goBack.bind(this)} src={BackArrow} />{this.state.data.general.labelSelectDataPreference}</h2>
												<div className="plans">
													<div className="price-c">
														<h5>{this.state.data.general.monthlyPlanPrice}</h5>
														<div className="price">
															<span className='unit'>$</span>{selectedPlan && selectedPlan.price}
														</div>
													</div>
													{selectedPlans &&
														<div className="plans-line" ref="dragBar" style={{ width: Math.min(100, (selectedPlans.length - 1) * 33) + '%' }}>
															<div className="line-container">
																<div className="line-color"></div>
																<div className="line-bg" style={{ width: Math.min(100, (1 - selectedPlanIndex / (selectedPlans.length - 1)) * 100) + '%' }}></div>
															</div>
															{selectedPlans.map((planId, index) => {
																const plan = self.state.data.plans[planId];
																const selectedPlansNumber_1 = selectedPlans.length - 1;
																const startHSL = rgbtohsl(230, 0, 126);
																const endHSL = rgbtohsl(99, 32, 128);
																const startColor = {
																	h: startHSL[0],
																	s: startHSL[1],
																	l: startHSL[2]
																};
																const endColor = {
																	h: endHSL[0],
																	s: endHSL[1],
																	l: endHSL[2]
																};
																const currentColor = {
																	h: (endColor.h - startColor.h) * index / selectedPlansNumber_1 + startColor.h,
																	s: (endColor.s - startColor.s) * index / selectedPlansNumber_1 + startColor.s,
																	l: (endColor.l - startColor.l) * index / selectedPlansNumber_1 + startColor.l
																}
																let className = 'data';
																if (index < selectedPlanIndex) {
																	className += ' highlight ';
																}
																else if (index === selectedPlanIndex) {
																	className += ' highlight active ';
																}
																else {
																	className += ' disabled ';
																}


																if (plan) {
																	return <span className={className} key={index}
																		onClick={self.onPlanChange.bind(self, planId)}
																		onMouseMove={self.onPlanDrag.bind(self, planId)}
																		onTouchMove={self.onPlanDrag.bind(self, planId)}
																		style={{ left: (index / (selectedPlans.length - 1)) * 100 + '%', width: 1 / (selectedPlans.length - 1) * 100 + '%' }}>
																		<span className="point" style={{ backgroundColor: 'hsl(' + currentColor.h + ', ' + currentColor.s + '%, ' + currentColor.l + '%)' }} ></span>
																		<span className="data-value">{plan.actualData === 'unlimited' ? plan.labelUnlimited : (plan.actualData + plan.actualDataUnit)}</span>
																	</span>
																}
																else {
																	return null;
																}
															})
															}
														</div>
													}

													<div className="shared">{(selectedPlan && selectedPlan.dataType) ? this.state.data.general[selectedPlan.dataType] : ''}</div>
												</div>

												<div className="ctas">
													<button className="next" tabIndex='-1' onClick={this.goToStep.bind(this, stepIndex + 1)}>{this.state.data.general.labelNext}</button>
													<a className='all-plans-mobile' href={this.state.data.general.urlViewAllPlans}>{this.state.data.general.labelViewAllPlans}</a>
												</div>
											</div>
										</div>
									}
								})
							}

							{selectedPlan &&
								<div className="step final" style={{ width: 100 / allStepCount + '%' }}>
									<div className="desc">
										<h2 className="title"><img alt="" className="back-arrow" onClick={self.goBack.bind(self)} src={BackArrow} />{selectedPlan.title}</h2>
										<p>{selectedPlan.text}</p>
										<div className="action">
											{/*<a onClick={()=>this.props.toPlanDetail(selectedPlan.planType, selectedPlan.planId)}  tabIndex='-1' className="cta">{this.state.data.general.labelSeePlanDetails}</a>*/}
											<a href={encodeURI(selectedPlan.url)}  tabIndex='-1' className="cta">{this.state.data.general.labelSeePlanDetails}</a>
											<br />
											<button className="go-back" tabIndex='-1' onClick={this.resetStep.bind(this)}>{this.state.data.general.labelGoBack}</button>
										</div>
									</div>
								</div>
							}

						</div>
					</div>
					{selectedPlan &&
						<div className={"detail-list" + (this.state.uiStep === theFinalStepIndex ? ' with-final ' : '')}>
							<div className="items">
								{
									Object.keys(selectedPlan.details)
										.map(key => {
											const detial = selectedPlan.details[key];
											return <div className="item" key={key}>
												<span className="label">
													<span className="top">{detial.label}</span>
													<span className="info">{detial.footnote}</span>
												</span>
												<span className={"value " + key}>{detial.value}</span>
											</div>
										})
								}
								<div className='line'></div>
							</div>

							<div className="caluseWrap">
								{this.state.data.general.labelTermsAndConditionsApply}
							</div>
						</div>
					}

				</div>
				{/*TODO: Add the link*/}
				<div className={'plan-link' + (startAdvisor ? ' in-steps ' : '') + (this.state.uiStep === theFinalStepIndex ? ' with-final ' : '')}>
					<a className='all-plans' href={this.state.data.general.urlViewAllPlans}>
						<span className='label'>{this.state.data.general.labelViewAllPlans}</span>
					</a>
				</div>



			</div>;
		} else {
			return null;
		}


	}
}


export default LookingPlan;